import React from 'react';
import GoogleSignup from './GoogleSignup';
import LinkedinSignup from './LinkedinSignup';
import { useTranslation } from 'react-i18next';
const SocialMediaButton = () => {
  const { t } = useTranslation('auth');
  return (
    <>
      <div className="text-[#85919F] text-center text-sm">
        {t('sign_in_using')}
      </div>
      <div className="flex justify-between gap-3 mt-2">
        <GoogleSignup />
        <LinkedinSignup />
      </div>
    </>
  );
};

export default SocialMediaButton;
